import type { IFaqItem } from '@/types/faq'

interface IPropTypes {
  faqs: IFaqItem[]
}

export default function ResourceFAQPublicList({ faqs }: IPropTypes) {
  if (!faqs || faqs.length === 0) {
    return null // Or some placeholder if no FAQs are provided
  }

  return (
    <div className='flex flex-col gap-2 divide-y py-2'>
      {faqs.map((faq) => (
        <div key={faq.id} className='p-2 px-4'>
          <p className='text-[14px] font-semibold'>
            {faq.position}. {faq.question}
          </p>
          <div
            dangerouslySetInnerHTML={{ __html: faq.answer }}
            className='prose-sm prose max-w-none overflow-hidden text-gray-600 dark:prose-invert dark:text-gray-300'
          />
        </div>
      ))}
    </div>
  )
}
